// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PU2-","input":"styles_input__2IFCO"};